module.exports = __webpack_public_path__ + "img/wheel_HIGH_lose.ac40e02a.png";